import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
};

export default function aluno(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.aluno;
        break;
      }
      case '@unidade/UNIDADE_CHOOSE_SUCCESS': {
        draft.profile = { ...state.profile, ...action.payload.aluno };
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        break;
      }
      default:
    }
  });
}
